import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Indemnizacion } from '../models/indemnizacion';
import { IndemnizacionConcepto } from '../models/indemnizacionConcepto';

const baseUrl = environment.hostService + '/Indemnizacion';

@Injectable({
  providedIn: 'root'
})
export class IndemnizacionService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(indemnizacion: Indemnizacion, indemnizacionConcepto: IndemnizacionConcepto[], cortarRegistro: boolean): Observable<any>
  {
    indemnizacion.indemnizacionConcepto = indemnizacionConcepto;
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: indemnizacion });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  deleteConcepto(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/DeleteConcepto?id=' + id });
  }

  guardarConcepto(data): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/UpdateConcepto', body: data, cacheMins: 0 });
  }

  mostrarConceptos(indemnizacionId: number)
  {
    return this._http.get<any>({ url: baseUrl + '/MostrarConceptos/' + indemnizacionId});
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        fecha: '00/00/0000',
        motivoBaja: '',
        errores: ['No Completar']}
    ];

    //motivoBaja se deben validar que existan

    return formato;
  }
  
}

